import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DateRangePicker } from 'react-date-range'
import { localeCalendar } from '../../helpers/traslation/traslation'
import { startOfMonth } from 'date-fns'

interface CalendarProps {
  onChange: (ranges: any) => void
}

const Calendar: React.FC<CalendarProps> = ({ onChange }) => {
  const { t } = useTranslation()
  const currentDate = new Date()
  const firstDayOfMonth = startOfMonth(currentDate)

  const spans = document.getElementsByClassName('rdrInputRange')

  const els = document.getElementsByClassName('rdrStaticRangeLabel')
  let spanishWords = [
    'Hoy',
    'Ayer',
    'Esta Semana',
    'Semana Pasada',
    'Este Mes',
    'Mes Pasado',
  ]
  let englishWords = [
    'Today',
    'Yesterday',
    'This Week',
    'Last Week',
    'This Month',
    'Last Month',
    'days up to today',
  ]
  let traslatedWords = [
    `${t('TODAY')}`,
    `${t('YESTERDAY')}`,
    `${t('THIS_WEEK')}`,
    `${t('LAST_WEEK')}`,
    `${t('THIS_MONTH')}`,
  ]

  let spanishPhrases = ['días hasta hoy', 'días a partir de hoy']
  let englishPhrases = ['days up to today', 'days starting today']
  let traslatePhrases = [
    `${t('DAYS_UP_TO_TODAY')}`,
    `${t('DAYS_STARTING_TODAY')}`,
  ]

  if (spans.length > 0) {
    for (var i = 0; i < spans.length; i++) {
      let string = spans[i] && spans[i].children[1].textContent
      if (string === spanishPhrases[i] || string === englishPhrases[i])
        spans[i].children[1].innerHTML = traslatePhrases[i]
      else spans[i].children[1].innerHTML = ''
    }
  }

  for (var i = 0; i < els.length; i++) {
    let string = els[i].textContent

    if (string === spanishWords[i] || string === englishWords[i])
      els[i].innerHTML = traslatedWords[i]
    else els[i].innerHTML = ''
  }

  const [state, setState] = useState([
    {
      startDate: firstDayOfMonth,
      endDate: currentDate,
      key: 'selection',
    },
  ])

  const handleChange = (ranges: any) => {
    const { selection } = ranges
    onChange(selection)
    setState([selection])
  }

  return (
    <div className='text text-size-075rem'>
      <DateRangePicker
        onChange={handleChange}
        moveRangeOnFirstSelection={false}
        months={1}
        ranges={state}
        direction='horizontal'
        locale={localeCalendar}
        rangeColors={['#f47524']}
        className='text text-size-075rem'
      />
    </div>
  )
}

export default Calendar
